import type {
    WeekdayShortName} from "@@/shared/parse-weekly-schedule";
import {
    swedishWeekdayShortNameLookup
} from "@@/shared/parse-weekly-schedule";
import type { DateAgnosticTimeRange } from "./date-agnostic-time-range";
import { dateAgnosticTimeToString } from "./date-agnostic-time-to-string";

const weekdayAvailabilityToString = (
    day: WeekdayShortName,
    ranges: DateAgnosticTimeRange[]
) => {
    return `${swedishWeekdayShortNameLookup[day]} ${ranges
        .map(
            range =>
                `${dateAgnosticTimeToString(
                    range.start
                )}-${dateAgnosticTimeToString(range.end)}`
        )
        .join(", ")}`;
};

export { weekdayAvailabilityToString };
